import Box from "@mui/material/Box";
import Typography from "components/common/Typography";
import { tokens } from "styles/Tokens";

interface Props {
  label: string;
  className?: string;
}

function PageTitle(props: Props) {
  const { label, className = "" } = props;

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        marginBottom: "24px"
      }}
      className={className}
    >
      <Typography variant="h3" color={tokens.Text.General.PrimaryHeadline} showBold>
        {label}
      </Typography>
    </Box>
  );
}

export default PageTitle;
